import { TaxOfficesGridView } from '~/components/system/tax-offices';
import { PageContainer } from '~/components/page-container';

export function TaxOffices() {
	return (
		<PageContainer>
			<TaxOfficesGridView />
		</PageContainer>
	);
}
